// source: pbtypes/gen/flight_connect/device_node_peer_health.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_connection_state_pb = require('../../../pbtypes/gen/flight_connect/connection_state_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_connection_state_pb);
var pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb = require('../../../pbtypes/gen/flight_connect/device_node_peer_local_rx_link_stats_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb);
var pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb = require('../../../pbtypes/gen/flight_connect/device_node_peer_remote_tx_link_stats_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb);
goog.exportSymbol('proto.flight_connect.DeviceNodePeerHealth', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceNodePeerHealth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_connect.DeviceNodePeerHealth.repeatedFields_, null);
};
goog.inherits(proto.flight_connect.DeviceNodePeerHealth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceNodePeerHealth.displayName = 'proto.flight_connect.DeviceNodePeerHealth';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_connect.DeviceNodePeerHealth.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceNodePeerHealth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceNodePeerHealth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodePeerHealth.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
state: jspb.Message.getFieldWithDefault(msg, 2, 0),
rxLoss: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
rttMs: jspb.Message.getFieldWithDefault(msg, 4, 0),
remoteToLocalMs: jspb.Message.getFieldWithDefault(msg, 5, 0),
localToRemoteMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
remoteTxLinkStatsList: jspb.Message.toObjectList(msg.getRemoteTxLinkStatsList(),
    pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb.DeviceNodePeerRemoteTxLinkStats.toObject, includeInstance),
localRxLinkStatsList: jspb.Message.toObjectList(msg.getLocalRxLinkStatsList(),
    pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb.DeviceNodePeerLocalRxLinkStats.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceNodePeerHealth}
 */
proto.flight_connect.DeviceNodePeerHealth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceNodePeerHealth;
  return proto.flight_connect.DeviceNodePeerHealth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceNodePeerHealth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceNodePeerHealth}
 */
proto.flight_connect.DeviceNodePeerHealth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.flight_connect.ConnectionState.Enum} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRxLoss(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRttMs(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRemoteToLocalMs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLocalToRemoteMs(value);
      break;
    case 7:
      var value = new pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb.DeviceNodePeerRemoteTxLinkStats;
      reader.readMessage(value,pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb.DeviceNodePeerRemoteTxLinkStats.deserializeBinaryFromReader);
      msg.addRemoteTxLinkStats(value);
      break;
    case 8:
      var value = new pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb.DeviceNodePeerLocalRxLinkStats;
      reader.readMessage(value,pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb.DeviceNodePeerLocalRxLinkStats.deserializeBinaryFromReader);
      msg.addLocalRxLinkStats(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceNodePeerHealth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceNodePeerHealth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodePeerHealth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRxLoss();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getRttMs();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getRemoteToLocalMs();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getLocalToRemoteMs();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getRemoteTxLinkStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb.DeviceNodePeerRemoteTxLinkStats.serializeBinaryToWriter
    );
  }
  f = message.getLocalRxLinkStatsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb.DeviceNodePeerLocalRxLinkStats.serializeBinaryToWriter
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ConnectionState.Enum state = 2;
 * @return {!proto.flight_connect.ConnectionState.Enum}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getState = function() {
  return /** @type {!proto.flight_connect.ConnectionState.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.flight_connect.ConnectionState.Enum} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional float rx_loss = 3;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getRxLoss = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.setRxLoss = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional uint32 rtt_ms = 4;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getRttMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.setRttMs = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 remote_to_local_ms = 5;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getRemoteToLocalMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.setRemoteToLocalMs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 local_to_remote_ms = 6;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getLocalToRemoteMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.setLocalToRemoteMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated DeviceNodePeerRemoteTxLinkStats remote_tx_link_stats = 7;
 * @return {!Array<!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats>}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getRemoteTxLinkStatsList = function() {
  return /** @type{!Array<!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_device_node_peer_remote_tx_link_stats_pb.DeviceNodePeerRemoteTxLinkStats, 7));
};


/**
 * @param {!Array<!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats>} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
*/
proto.flight_connect.DeviceNodePeerHealth.prototype.setRemoteTxLinkStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.addRemoteTxLinkStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.flight_connect.DeviceNodePeerRemoteTxLinkStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.clearRemoteTxLinkStatsList = function() {
  return this.setRemoteTxLinkStatsList([]);
};


/**
 * repeated DeviceNodePeerLocalRxLinkStats local_rx_link_stats = 8;
 * @return {!Array<!proto.flight_connect.DeviceNodePeerLocalRxLinkStats>}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.getLocalRxLinkStatsList = function() {
  return /** @type{!Array<!proto.flight_connect.DeviceNodePeerLocalRxLinkStats>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_device_node_peer_local_rx_link_stats_pb.DeviceNodePeerLocalRxLinkStats, 8));
};


/**
 * @param {!Array<!proto.flight_connect.DeviceNodePeerLocalRxLinkStats>} value
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
*/
proto.flight_connect.DeviceNodePeerHealth.prototype.setLocalRxLinkStatsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.flight_connect.DeviceNodePeerLocalRxLinkStats=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.DeviceNodePeerLocalRxLinkStats}
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.addLocalRxLinkStats = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.flight_connect.DeviceNodePeerLocalRxLinkStats, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.DeviceNodePeerHealth} returns this
 */
proto.flight_connect.DeviceNodePeerHealth.prototype.clearLocalRxLinkStatsList = function() {
  return this.setLocalRxLinkStatsList([]);
};


goog.object.extend(exports, proto.flight_connect);
